module.exports = __webpack_public_path__ + "images/help_v2/avatars/canglang-4168de13b15fb7243043f8ce06245fc0.png";